import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import MetaTags from "./MetaTags";
import ChevDown from "../../assets/svg/ChevDown";
import ChevUp from "../../assets/svg/ChevUp";

const faqs_client = [
  {
    question: "What is Anyaya?",
    answer:
      "Anyaya is your go-to app for discovering and booking trusted event suppliers in just a few taps. Whether you're planning a birthday, wedding, corporate event, or any celebration, we make the process easier and more organized for you.",
  },
  {
    question: "What types of suppliers can I find on the app?",
    answer:
      "A wide variety! You’ll find hosts, coordinators, stylists, makeup artists, photographers, videographers, florists, caterers, bakers, mobile bars, venues, lights and sounds, DJs, bands, rental services, invitation designers, souvenir shops, and even digital suppliers like virtual hosts or content creators.",
  },
  {
    question: "Is Anyaya free to use?",
    answer:
      "Yes, Anyaya is completely free to download and use! Just search “Anyaya” on the Google Play Store (for Android) or the App Store (for Apple users) and install the app. You can browse, chat with suppliers, and explore services without any charge. You only pay whenever you book a service.",
  },
  {
    question: "How do I book a supplier?",
    answer:
      "Simply search a category, choose a preferred merchant, browse their portfolio, then tap “Book Now”. You’ll be guided through the steps to confirm your booking.",
  },
  {
    question: "Can I message suppliers before booking?",
    answer:
      "Absolutely! You can message a merchant directly by tapping the “Inquire” button on a merchant’s listing page to ask questions or clarify details before making a booking.",
  },
  {
    question: "Is it safe to book and pay through the app?",
    answer:
      "Yes. Anyaya uses secure payment systems and is partnered with Maya to ensure your transactions are protected. We also verify our suppliers for added peace of mind.",
  },
  {
    question: "What are the accepted payment methods?",
    answer:
      "Aside from Maya, other payment methods like GCash, bank transfers, credit/debit cards, and other app-based wallets are also accepted.",
  },
  {
    question: "Will I get a booking confirmation?",
    answer:
      "Yes. Once the booking is finalized, you’ll receive a confirmation via the app and your email.",
  },
  {
    question: "Can I cancel a booking?",
    answer:
      "Yes, you can. Just review the supplier’s cancellation terms to see if any penalties or deadlines apply.",
  },
  {
    question: "What happens if a supplier cancels on me?",
    answer:
      "In the rare case a supplier cancels, you’ll have to notify us to get a refund.",
  },
  {
    question: "Can I book multiple suppliers in one go?",
    answer:
      "Yes! You can book different suppliers for different services all within the same app.",
  },
  {
    question: "Do I need an account to book?",
    answer:
      "Yes, having an account allows you to track your bookings, manage payments, and communicate easily with suppliers.",
  },
  {
    question: "How can I be sure the suppliers are legit?",
    answer:
      "Our Merchant’s go through a verification process wherein business permits are verified. Look for the “Recognized Badge” on their profile. You can also check their listings for reviews from past clients.",
  },
  {
    question: "Can I see reviews or ratings from other clients?",
    answer:
      "Definitely. Reviews and ratings are visible on each supplier’s profile to help you book with confidence.",
  },
  {
    question: "Is there a way to save or shortlist suppliers I like?",
    answer:
      "Yes, just tap the heart icon on a supplier’s profile to save them to your favorites.",
  },
  {
    question: "Do you offer promo codes or discounts?",
    answer:
      "Yes! We roll out promos regularly. Follow us on social media or check the app for ongoing discounts and vouchers.",
  },
  {
    question: "Can I rebook or repeat a past service?",
    answer:
      "Yes, you can easily rebook a past supplier from your previous bookings.",
  },
  {
    question: "Where is Anyaya available?",
    answer:
      "Anyaya is available across the Philippines, from major cities to provinces—helping you find the right supplier wherever your event is.",
  },
  {
    question: "How can I contact customer support?",
    answer:
      "You can reach us via the in-app chat, email, or through our official social media channels. We’re here to help!",
  },
];
const faqs_merchant = [
  {
    question: "How can I sign up as a supplier on Anyaya?",
    answer:
      "Download the Anyaya App, tap “Become a Merchant”, and complete your profile. You’ll be guided step-by-step. Our team will review your details and help verify your listing.",
  },
  {
    question: "Is there a registration or listing fee?",
    answer: (
      <>
        There’s no fee to join with a basic listing. If you want access to extra
        features, you can upgrade to <strong>AnyayaPro</strong>.
      </>
    ),
  },

  {
    question: "What types of businesses or services can join?",
    answer: (
      <>
        <p className="mb-2">
          Any event-related service is welcome! This includes:
        </p>
        <ul className="list-disc list-inside space-y-1">
          <li>Hosts & Coordinators</li>
          <li>Stylists & Designers</li>
          <li>Caterers & Bakers</li>
          <li>Photographers & Videographers</li>
          <li>Makeup Artists & Hair Stylists</li>
          <li>Musicians, DJs & Live Performers</li>
          <li>Venues & Rental Spaces</li>
          <li>Invitation Makers & Souvenir Shops</li>
          <li>Event Rentals (tables, chairs, tents, etc.)</li>
          <li>
            Digital Services (e-invites, virtual hosting, video editing, etc.)
          </li>
          <li>Lights & Sounds Providers</li>
          <li>Mobile Bars & Specialty Booths</li>
          <li>Event Planners, Decorators, and more</li>
        </ul>
      </>
    ),
  },

  {
    question: "What are the requirements to get verified?",
    answer:
      "To get verified, submit a valid ID, proof of services (like sample work or portfolio), and your business details. This helps build trust with clients.",
  },
  {
    question: "How will clients discover and contact me?",
    answer:
      "Clients can find you through category searches and filters. They can message you directly through the app before booking.",
  },
  {
    question: "Can I set my own packages, prices, and schedule?",
    answer:
      "Yes, you have full control over your pricing, packages, and calendar availability.",
  },
  {
    question: "Can I decline or cancel a booking?",
    answer:
      "Yes, but please cancel responsibly. Cancellations may affect your ratings and visibility in the app.",
  },
  {
    question: "How and when do I receive payments?",
    answer:
      "Payments are processed through the app. Once the service is completed and confirmed, you’ll receive your earnings within 3 to 5 working days via your chosen payout method.",
  },
  {
    question: "What happens if a client cancels or raises a concern?",
    answer:
      "We handle disputes fairly and according to app policies. Always be clear with your cancellation and refund terms in your listing.",
  },
  {
    question: "Can I receive reviews and ratings from clients?",
    answer:
      "Yes! After each completed booking, clients can leave a review that will appear on your profile.",
  },
  {
    question: "Can I offer promos or discounts in my profile?",
    answer:
      "Yes, you can highlight seasonal promos or exclusive offers to attract more clients.",
  },
  {
    question: "Can I upload photos, videos, or a portfolio of my work?",
    answer:
      "Absolutely! Your profile should showcase your best work—add photos and videos.",
  },
  {
    question: "Will I receive notifications for messages and bookings?",
    answer:
      "Yes, you’ll get real-time notifications so you never miss an inquiry or confirmed booking.",
  },
  {
    question: "Can I pause or deactivate my listing temporarily?",
    answer:
      "Yes, you can set your profile to pause mode if you’re unavailable or taking a break.",
  },
  {
    question: "Is there a premium listing or upgrade option available?",
    answer: (
      <>
        Yes! Our <strong>AnyayaPro</strong> upgrade gives you access to premium
        features like increased visibility, featured listings, profile badges,
        and marketing boosts. With <strong>AnyayaPro</strong>, you’ll have
        access to customers that are currently looking for suppliers and you can
        send them offers directly.
      </>
    ),
  },
  {
    question: "What’s the difference between Basic and AnyayaPro listings?",
    answer: (
      <>
        Basic is free and includes standard features. <strong>AnyayaPro</strong>{" "}
        unlocks exclusive tools and upgrades that help boost your profile and
        get more bookings.
      </>
    ),
  },

  {
    question: "Can I boost my visibility in the app?",
    answer: (
      <>
        Yes. Upgrading to <strong>AnyayaPro</strong>, maintaining great reviews,
        and responding quickly to clients will help you appear higher in search
        results.
      </>
    ),
  },
  {
    question: "Can I join if I only offer digital services?",
    answer:
      "Yes, we welcome digital service providers too—like online hosting, virtual event planning, and video/photo editing.",
  },
  {
    question: "What areas or locations can I serve on the app?",
    answer:
      "You can provide a service to anyone from anywhere in the Philippines.",
  },
  {
    question: "Who is Anyaya’s payment partner?",
    answer:
      "Our main payment partner is Maya, but we also support other modes like GCash, debit/credit cards, and bank transfers—depending on client and merchant preferences.",
  },
];

const navItems = [
  "FAQs",
  "About Anyaya Platform",
  "About Merchants & Security",
];

export default function Support() {
  const [active, setActive] = useState(0);
  const [openIndex, setOpenIndex] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [active]);
  const proceedToEmail = () => {
    window.location.href = "mailto:support@anyaya-events.com";
  };

  return (
    <div className="px-8 lg:px-40 xl:px-56 pb-10 pt-6 align-center  flex">
      <Helmet>
        <MetaTags
          title="Help Center"
          description="Help Center"
          keywords="genuine event merchants"
        />
      </Helmet>
      {/* Sidebar */}
      <aside className="w-64 sticky top-24 self-start h-fit">
        <div className="text-[24px] font-semibold text-primary-500 mb-6">
          Help Center
        </div>
        <nav className="space-y-2">
          {navItems.map((item, idx) => (
            <div
              key={idx}
              className={`cursor-pointer text-[14px] px-3 py-2 ${
                idx === active
                  ? "text-sunrise-500 font-semibold border-l-4 border-sunrise-500 bg-gray-100"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
              onClick={() => setActive(idx)}
            >
              {item}
            </div>
          ))}
        </nav>
      </aside>

      {/* Content */}
      <main className="border-l border-gray-200  flex-1 px-12 py-8">
        {active === 0 && (
          <>
            <h3 className="text-[20px] font-semibold text-primary-500 mb-6">
              Frequently Asked Questions
            </h3>

            <div className="space-y-2">
              <h3 className="text-[20px] font-semibold text-sunrise-500 mb-6">
                For Clients / Users
              </h3>
              {faqs_client.map((faq, index) => (
                <div key={index} className="border-b border-gray-150">
                  <button
                    onClick={() =>
                      setOpenIndex(openIndex === index ? null : index)
                    }
                    className="w-full flex justify-between items-center px-4 py-3 text-left text-[16px] font-medium text-gray-800 focus:outline-none"
                  >
                    <span>{`${index + 1}. ${faq.question}`}</span>
                    <span>
                      {openIndex === index ? <ChevUp /> : <ChevDown />}
                    </span>
                  </button>
                  {openIndex === index && faq.answer && (
                    <div className="p-4 text-[16px] text-gray-550 bg-gray-50">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="space-y-2 my-6">
              <h3 className="text-[20px] font-semibold text-sunrise-500 mb-6">
                For Suppliers / Merchants
              </h3>
              {faqs_merchant.map((faq, index) => (
                <div key={index} className="border-b border-gray-150">
                  <button
                    onClick={() =>
                      setOpenIndex(openIndex === index ? null : index)
                    }
                    className="w-full flex justify-between items-center px-4 py-3 text-left text-[16px] font-medium text-gray-800 focus:outline-none"
                  >
                    <span>{`${index + 1}. ${faq.question}`}</span>
                    <span>
                      {openIndex === index ? <ChevUp /> : <ChevDown />}
                    </span>
                  </button>
                  {openIndex === index && faq.answer && (
                    <div className="p-4 text-[16px] text-gray-550 bg-gray-50">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
        {active === 1 && (
          <div className="mt-5">
            <h1 className="mb-5 text-primary-500 text-[20px] font-semibold">
              Understanding About Anyaya
            </h1>
            <p className="text-[16px]">
              Anyaya is an events marketplace that anyone can access for free.
              We aim to directly connect customers to capable event experts for
              their services. Anyaya makes it easy for customers to have access
              to the best options when it comes to event coverage, set design,
              concepts, food and drink, and anything that brings their personal
              and beloved moments to life.
            </p>
            {/* <h2 className="mt-5 font-semibold text-[16px]">
            Talk to the merchant first before booking.
          </h2>
          <p className="text-[16px]">
            It is always best to confirm with the merchant their service and
            supply details. Simply check their listing details, ask questions
            and negotiate if you need additional service for your event. Our
            chat system is available 24/7.
          </p> */}
            <h2 className="mt-5 font-semibold text-[20px] text-primary-500">
              Confirm, Request, Reserve.
            </h2>
            <p className="text-[16px]">
              <span className="font-semibold">Confirm</span> with the merchant
              if your needs will be met;{" "}
              <span className="font-semibold">Request</span> to book a date;{" "}
              <span className="font-semibold">Pay & Reserve</span> for your
              event.
            </p>

            <h2 className="mt-5 font-semibold text-[20px] text-primary-500">
              Modify event details.
            </h2>
            <p className="text-[16px]">
              When something came up and you have to reschedule your event, just
              simply notify the merchant for any changes in your plans.
            </p>
          </div>
        )}
        {active === 2 && (
          <div className="mt-5">
            <h2 className="font-semibold text-primary-500 text-[20px]">
              Genuineness of the Merchants.
            </h2>
            <p className="text-[16px]">
              Our mission is to provide secure and smooth customer connections
              with trusted event merchants providing exceptional services. We
              make sure that all of the merchants bear the necessary permits to
              operate in the Republic of the Philippines. With that being said,
              Anyaya will still not hold any liability to any damages that may
              occur during any event booked in the platform.
            </p>
            <h2 className="mt-5 font-semibold text-[20px] text-primary-500">
              Diversification.
            </h2>
            <p className="text-[16px]">
              One of our goals is to present a well-organized platform with
              variety, and we do this by filtering merchants down to uniqueness
              and supreme functionality.
            </p>

            <h2 className="mt-5 font-semibold text-[20px] text-primary-500">
              Payment Security and Convenience.
            </h2>
            <p className="text-[16px]">
              Our payment system is powered by Maya Business. We prioritize
              payment security intently, and we make sure that any payment
              detail is delicately handled.
            </p>

            <h2 className="mt-5 font-semibold text-[20px] text-primary-500">
              Anyaya Service Fee.
            </h2>
            <p className="text-[16px]">
              Anyaya charges a very minimal service fee. This will allow the
              platform to further operate, develop, and enhance its services to
              better serve the customers. We reserve the right to alter our
              service fees any time and terminate any account that we may find
              to violate any agreement stated in the Terms & Conditions and
              Privacy Policy.
            </p>
          </div>
        )}
        {active !== 0 && (
          <>
            <h2 className="mt-5 font-semibold text-[20px] text-primary-500">
              Contact us.
            </h2>
            <p className="text-[16px]">
              If you need further assistance, kindly message us on chat support
              or email us at
              <span
                className="text-sunrise-500 font-semibold cursor-pointer text-[16px] text-left pb-2"
                onClick={() => proceedToEmail()}
              >
                {" "}
                support@anyaya-events.com{" "}
              </span>
            </p>
          </>
        )}
      </main>
    </div>
  );
}
